import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData, {
  getOrganizationSchema,
  getBreadcrumbSchema,
  getWebPageSchema,
} from '@/components/feature/StructuredData';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    document.title = '关于我们 - 黑料718 | 品牌介绍与联系我们';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '了解黑料718——中国领先的吃瓜爆料平台。品牌介绍、发展历程、媒体评价与联系方式，致力于为用户提供真实、快速、全面的娱乐资讯服务。');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://heiliao718.com/about');
    }
  }, []);

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d96dqqcut53jbls7kn1g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || (parsed?.meta?.detail && parsed.meta.detail.includes('spam'))) {
          setFormStatus('error');
          setFormError('提交失败，请稍后重试');
        } else {
          setFormStatus('error');
          setFormError(serverMsg);
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  const teamMembers = [
    { name: '张明远', role: '创始人 & CEO', desc: '前知名互联网公司高管，深耕内容行业15年' },
    { name: '李晓婷', role: '总编辑', desc: '资深媒体人，曾任职于多家主流媒体' },
    { name: '王大伟', role: '技术负责人', desc: '全栈工程师，负责平台技术架构与安全' },
  ];

  const reviews = [
    { user: '新浪娱乐', text: '黑料718以快速、准确的娱乐爆料在行业内建立了良好口碑，是国内领先的吃瓜资讯平台之一。', role: '媒体评价' },
    { user: '腾讯新闻', text: '作为新兴的娱乐资讯聚合平台，黑料718凭借独特的内容视角和用户互动模式，迅速积累了庞大的用户群体。', role: '媒体报道' },
    { user: '张女士', text: '每天必刷的APP！更新速度快，内容真实度高，评论区也很有趣，是吃饭时的绝佳伴侣。', role: '忠实用户' },
    { user: '李先生', text: '从最初用网页版到后来下载APP，黑料718陪我度过了无数个摸鱼时光。内容质量一直很稳定。', role: '三年老用户' },
    { user: '网易娱乐', text: '在众多娱乐资讯平台中，黑料718以其独特的定位和优质的用户体验脱颖而出，成为吃瓜爱好者的首选平台。', role: '行业评论' },
  ];

  return (
    <>
      <StructuredData data={getOrganizationSchema()} />
      <StructuredData
        data={getWebPageSchema(
          '关于我们 - 黑料718',
          '了解黑料718品牌故事、团队介绍、媒体评价及联系方式。中国领先的吃瓜爆料平台。',
          'https://heiliao718.com/about'
        )}
      />
      <StructuredData
        data={getBreadcrumbSchema([
          { name: '首页', url: 'https://heiliao718.com' },
          { name: '关于我们', url: 'https://heiliao718.com/about' },
        ])}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero */}
          <section className="relative pt-16">
            <div className="relative w-full min-h-[380px] md:min-h-[460px] flex items-center justify-center overflow-hidden bg-background-100">
              <div className="relative z-10 w-full max-w-2xl mx-auto text-center px-4 py-12">
                <nav className="flex items-center justify-center gap-2 text-xs text-foreground-400 mb-4 flex-wrap">
                  <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
                    首页
                  </Link>
                  <i className="ri-arrow-right-s-line"></i>
                  <span className="text-foreground-600 whitespace-nowrap">关于我们</span>
                </nav>
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
                  关于黑料718
                </span>
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
                  吃瓜，我们是
                  <br />
                  <span className="text-primary-500">认真的</span>
                </h1>
                <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
                  黑料718成立于2020年，致力于打造中国最专业、最全面的吃瓜爆料聚合平台。
                  每日更新海量娱乐资讯，为数千万用户提供真实、快速、有趣的吃瓜体验。
                </p>
              </div>
            </div>
          </section>

          {/* Brand Story - Feature Grid */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <p className="text-xs font-label font-semibold uppercase tracking-widest text-foreground-400 mb-2">
                  黑料718 · 品牌使命
                </p>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  让每一条爆料都有价值
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {/* Mission Card */}
                <div className="bg-foreground-950 rounded-xl p-6 md:p-8 text-background-50">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 mb-5">
                    <i className="ri-focus-3-line text-xl"></i>
                  </div>
                  <h3 className="text-xl font-heading font-bold text-background-50 mb-3">我们的使命</h3>
                  <p className="text-sm text-background-50/70 leading-relaxed">
                    打破信息壁垒，让真相不再沉默。为每一个普通人提供发声渠道，让公众有权利了解娱乐圈和社会的真实面貌。
                  </p>
                </div>

                {/* Image Card */}
                <div className="relative rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20open%20office%20workspace%20with%20diverse%20team%20collaborating%2C%20warm%20natural%20lighting%2C%20creative%20atmosphere%2C%20startup%20culture%2C%20editorial%20office%20photography%2C%20casual%20professional%20style&width=600&height=400&seq=about-team-photo&orientation=landscape"
                    alt="黑料718团队"
                    title="黑料718团队 - 专业吃瓜爆料平台"
                    className="w-full h-full aspect-[4/3] object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 px-3 py-1 bg-foreground-950/60 text-background-50 text-xs rounded-full whitespace-nowrap">
                    <i className="ri-team-line mr-1"></i>
                    我们的团队
                  </div>
                  <div className="absolute bottom-4 left-4">
                    <p className="text-background-50 text-lg font-heading font-bold">专业 · 高效 · 热爱</p>
                  </div>
                </div>

                {/* Stats Card */}
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
                  <p className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">328万+</p>
                  <p className="text-sm text-foreground-500 mt-1 mb-6">日活跃用户数</p>
                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-bold text-foreground-950">15,000+</p>
                      <p className="text-xs text-foreground-400">每日更新爆料</p>
                    </div>
                    <div className="w-full h-px bg-background-200/70"></div>
                    <div>
                      <p className="text-lg font-bold text-foreground-950">99.7%</p>
                      <p className="text-xs text-foreground-400">用户满意度</p>
                    </div>
                    <div className="w-full h-px bg-background-200/70"></div>
                    <div>
                      <p className="text-lg font-bold text-foreground-950">50+</p>
                      <p className="text-xs text-foreground-400">专业编辑团队</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Team & Intro */}
          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-8 items-center">
                <div className="w-full lg:w-1/2">
                  <div className="rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Spacious%20modern%20office%20interior%20with%20collaborative%20workspace%2C%20plants%20and%20natural%20light%2C%20creative%20startup%20environment%2C%20warm%20wood%20accents%2C%20minimalist%20design%2C%20editorial%20interior%20photography&width=800&height=600&seq=about-office-wide&orientation=landscape"
                      alt="黑料718办公环境"
                      title="黑料718 - 办公环境"
                      className="w-full aspect-[4/3] object-cover object-top"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
                    品牌故事
                  </span>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 leading-snug">
                    从一颗吃瓜的心开始
                  </h2>
                  <div className="mt-4 space-y-3 text-sm text-foreground-600 leading-relaxed">
                    <p>
                      黑料718诞生于2020年，最初只是一个由几位娱乐圈资深从业者共同运营的小型爆料博客。
                      凭借对内容真实性的严格把控和独特的编辑视角，在短短几年内成长为拥有超过三千万用户的一站式吃瓜平台。
                    </p>
                    <p>
                      我们始终坚持「内容为王」的核心理念，组建了一支由资深媒体人、娱乐记者和数据分析师组成的专业团队。
                      每一条爆料在发布前都经过严格的多方核实，确保为用户提供真实可靠的资讯。
                    </p>
                    <p>
                      除了内容质量，我们同样重视用户体验和隐私保护。黑料718自主研发的匿名爆料系统，采用银行级加密技术，
                      确保每一位爆料人的身份信息安全无虞。
                    </p>
                  </div>
                </div>
              </div>

              {/* Team Members */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-10">
                {teamMembers.map((member) => (
                  <div
                    key={member.name}
                    className="bg-background-50 rounded-lg border border-background-200/70 p-5 text-center"
                  >
                    <div className="w-16 h-16 mx-auto rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-heading font-bold text-lg">
                      {member.name.charAt(0)}
                    </div>
                    <h3 className="mt-3 text-base font-heading font-semibold text-foreground-950">{member.name}</h3>
                    <p className="text-xs text-primary-500 font-medium mt-0.5">{member.role}</p>
                    <p className="text-xs text-foreground-500 mt-2">{member.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Reviews */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                  媒体与用户评价
                </span>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  他们说
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {/* First column - 2 cards */}
                <div className="space-y-4">
                  {reviews.slice(0, 2).map((review, idx) => (
                    <div key={idx} className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-bold text-xs">
                          {review.user.charAt(0)}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-900">{review.user}</p>
                          <p className="text-xs text-foreground-400">{review.role}</p>
                        </div>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed italic">
                        「{review.text}」
                      </p>
                    </div>
                  ))}
                </div>

                {/* Second column - image card */}
                <div className="relative rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20newsroom%20with%20journalists%20working%20on%20computers%2C%20modern%20media%20office%2C%20warm%20lighting%2C%20editorial%20environment%2C%20documentary%20style%20photography&width=500&height=700&seq=about-review-image&orientation=portrait"
                    alt="媒体评价"
                    title="黑料718 - 媒体评价与口碑"
                    className="w-full h-full aspect-[3/4] object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-background-50 text-lg font-heading font-bold">行业认可</p>
                    <p className="text-background-50/70 text-xs mt-1">多家主流媒体的真实评价</p>
                  </div>
                </div>

                {/* Third column - 2 cards */}
                <div className="space-y-4">
                  {reviews.slice(2).map((review, idx) => (
                    <div key={idx} className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-bold text-xs">
                          {review.user.charAt(0)}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-900">{review.user}</p>
                          <p className="text-xs text-foreground-400">{review.role}</p>
                        </div>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed italic">
                        「{review.text}」
                      </p>
                    </div>
                  ))}
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center font-bold text-xs">
                        好
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">应用商店评分</p>
                        <p className="text-xs text-foreground-400">来自真实用户</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                      <span className="text-sm font-bold text-foreground-900 ml-2">4.9</span>
                    </div>
                    <p className="text-xs text-foreground-400 mt-1">基于 128,000+ 条评价</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contact Form */}
          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                  联系我们
                </span>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  期待你的声音
                </h2>
                <p className="text-xs text-foreground-500 mt-1">
                  商务合作、内容投稿、问题反馈，欢迎随时联系我们
                </p>
              </div>

              <form
                data-readdy-form
                onSubmit={handleContactSubmit}
                className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8 space-y-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="subject" className="block text-xs font-medium text-foreground-700 mb-1.5">
                    主题
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-700 focus:outline-none focus:border-primary-300 transition-colors cursor-pointer"
                  >
                    <option value="商务合作">商务合作</option>
                    <option value="内容投稿">内容投稿</option>
                    <option value="问题反馈">问题反馈</option>
                    <option value="其他咨询">其他咨询</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  />
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  className="form-honeypot"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  {formStatus === 'loading' ? '提交中...' : '发送留言'}
                </button>

                {formStatus === 'success' && (
                  <p className="text-center text-sm text-green-600">
                    感谢您的留言！我们会尽快回复您。
                  </p>
                )}
                {formStatus === 'error' && formError && (
                  <p className="text-center text-sm text-red-500">
                    {formError}
                  </p>
                )}
              </form>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}